/**
 * Page numbers to draw (`null` = ellipsis): both ends, `page`, and `siblings` (default 1) either side of it.
 * Windowed because a 500-position ceiling at five rows a page is a hundred numbers, not the mockup's two.
 */
export const paginationWindow = (
  page: number,
  pageCount: number,
  siblings = 1,
): (number | null)[] => {
  const pages = new Set([0, pageCount - 1, page]);
  for (let offset = 1; offset <= siblings; offset++) {
    pages.add(page - offset).add(page + offset);
  }
  const shown = [...pages]
    .filter((candidate) => candidate >= 0 && candidate < pageCount)
    .sort((a, b) => a - b);

  return shown.flatMap((candidate, index) =>
    index > 0 && candidate - shown[index - 1] > 1
      ? [null, candidate]
      : [candidate],
  );
};
